import { shallow } from 'zustand/shallow'

import Container from 'src/ui/molecules/Container'
import NetworkAndChainSelector from 'src/ui/molecules/NetworkAndChainSelector'
import { useChainAndNetwork } from 'src/store/chainAndNetwork'

import EvmForm from './EvmForm'
import EsdtForm from './EsdtForm'

const IssueToken = () => {
  const { chain, network } = useChainAndNetwork(
    (state) => ({
      chain: state.chain,
      network: state.network,
    }),
    shallow,
  )
  const chainForm = () => {
    switch (chain) {
      case 'bnb':
      case 'ethereum':
      case 'polygon':
        return <EvmForm chain={chain} network={network} />
      case 'multiversx':
      default:
        return <EsdtForm network={network} />
    }
  }

  return (
    <Container>
      <div className="grid gap-12">
        <NetworkAndChainSelector />

        {chainForm()}
      </div>
    </Container>
  )
}

export default IssueToken
